import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import Assemble from './assemble/Assemble'
import Create from './create/Create'
import Explore from './explore/Explore'
import Landing from './landing/Landing'
import Learn from './learn/Learn'
import Produce from './produce/Produce'
import Shape from './shape/Shape'

interface PageList {
  [key: string]: JSX.Element
}

const PageRouter = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.pathname])

  const match = location.pathname.match(/page-([^/.]+)/)
  const page = match ? match[1] : null

  /* For local dev use  REACT_APP_USE_LOCAL_ROUTING="1" */
  const pageList: PageList = {
    assemble: <Assemble />,
    create: <Create />,
    explore: <Explore />,
    learn: <Learn />,
    produce: <Produce />,
    shape: <Shape />,
  }

  if (!page) {
    return <Landing />
  }
  return pageList[page] || <Landing />

  /*--- in decoupled not using application id as of now, so no need to differentiate staging and prod urls. Below is the code for reference if we need to use full urls for routing in future. ---*/
  // {
  //   /*
  //   Staging/Prod. Page urls are read from
  //   REACT_APP_PAGE_[VALUE]_URL vars. In stage/prod,
  //   URL consists of .../application/app_id/page-[value]
  //   */

  //   const assembleUrl = process.env.REACT_APP_PAGE_ASSEMBLE_URL || ''
  //   const exploreUrl = process.env.REACT_APP_PAGE_EXPLORE_URL || ''
  //   const createUrl = process.env.REACT_APP_PAGE_CREATE_URL || ''
  //   const shapeUrl = process.env.REACT_APP_PAGE_SHAPE_URL || ''
  //   const produceUrl = process.env.REACT_APP_PAGE_PRODUCE_URL || ''
  //   const learnUrl = process.env.REACT_APP_PAGE_LEARN_URL || ''

  //   const match = fullUrl.match(/\/application\/([^?#]*)/)
  //   const page = match ? match?.[1] : null

  //   if (!page) return <Landing />

  //   const pageMapper: PageList = {
  //     [assembleUrl]: <Assemble />,
  //     [createUrl]: <Create />,
  //     [exploreUrl]: <Explore />,
  //     [learnUrl]: <Learn />,
  //     [produceUrl]: <Produce />,
  //     [shapeUrl]: <Shape />,
  //   }

  //   return pageMapper[page] || <Landing />
  // }
}

export default PageRouter
